import { useState } from 'react';
import { Link } from 'react-router-dom';

const CONTENT_RULES = [
  '不得包含任何违反中华人民共和国法律法规的内容',
  '不得涉及政治敏感话题、分裂国家、颠覆政权等内容',
  '不得包含色情、暴力、恐怖主义等违禁内容',
  '不得侵犯他人知识产权、肖像权、隐私权',
  '不得发布虚假信息、谣言或误导性内容',
  '内容须与科技、未来、元宇宙等主题相关',
  '须为原创作品，不得抄袭或剽窃',
  '平台保留对所有上传内容进行审核的权利',
  '审核通过后方可发布，审核周期为3-7个工作日',
  '违规内容将被删除，严重违规将封禁账号并追究法律责任',
];

const REVENUE_RULES = [
  { icon: 'ri-money-cny-circle-line', title: '收益分成比例', desc: '作者获得总收入的60%，平台获得40%', color: '#FFD700' },
  { icon: 'ri-calendar-check-line', title: '结算周期', desc: '每月15日结算上月收益，通过支付宝或银行转账', color: '#00FFCC' },
  { icon: 'ri-shield-check-line', title: '最低提现门槛', desc: '账户余额满¥100元方可申请提现', color: '#00FF88' },
  { icon: 'ri-file-text-line', title: '收益来源', desc: '读者付费解锁（¥8.88/故事）的60%归作者所有', color: '#FF6B9D' },
  { icon: 'ri-user-star-line', title: '优质内容奖励', desc: '月度优质作品可获得平台额外奖励，最高¥10,000', color: '#A855F7' },
  { icon: 'ri-copyright-line', title: '版权归属', desc: '作者保留作品版权，平台获得非独家展示授权', color: '#FF6B35' },
];

export default function StoryUploadPage() {
  const [agreed, setAgreed] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ title: '', tech: '', year: '', teaser: '', content: '', email: '', name: '', payAccount: '' });
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!agreed) return;
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen" style={{ background: '#060A14', fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      <nav className="sticky top-0 z-50 border-b" style={{ background: 'rgba(6,10,20,0.95)', borderColor: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(20px)' }}>
        <div className="max-w-[1000px] mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm font-medium text-white/50 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line" />返回首页
          </Link>
          <span className="text-white font-bold text-sm">上传我的作品</span>
          <div />
        </div>
      </nav>

      <div className="max-w-[1000px] mx-auto px-6 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6" style={{ background: 'rgba(255,215,0,0.12)', border: '1.5px solid rgba(255,215,0,0.4)', color: '#FFD700' }}>
            <i className="ri-upload-cloud-line" />
            创作者计划 · 上传你的科幻故事
          </div>
          <h1 className="text-3xl md:text-4xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            成为 META66 <span style={{ color: '#FFD700' }}>创作者</span>
          </h1>
          <p className="text-white/50 text-base max-w-2xl mx-auto leading-relaxed">
            上传你的科幻故事，与全球读者分享你对未来的想象。
            优质作品将获得付费收益，作者可获得总收入的 <span className="text-[#FFD700] font-bold">60%</span>。
          </p>
        </div>

        {/* Revenue Rules */}
        <div className="mb-10 p-6 rounded-3xl" style={{ background: 'rgba(255,215,0,0.05)', border: '1px solid rgba(255,215,0,0.2)' }}>
          <h2 className="text-white font-black text-xl mb-6 flex items-center gap-2">
            <i className="ri-money-cny-circle-line text-[#FFD700]" />
            创作者收益规则
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {REVENUE_RULES.map(rule => (
              <div key={rule.title} className="p-4 rounded-2xl" style={{ background: `${rule.color}08`, border: `1px solid ${rule.color}20` }}>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: `${rule.color}20` }}>
                    <i className={`${rule.icon} text-sm`} style={{ color: rule.color }} />
                  </div>
                  <span className="text-white font-bold text-sm">{rule.title}</span>
                </div>
                <p className="text-white/50 text-xs leading-relaxed">{rule.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Content Rules */}
        <div className="mb-10 p-6 rounded-3xl" style={{ background: 'rgba(255,68,68,0.05)', border: '1px solid rgba(255,68,68,0.2)' }}>
          <h2 className="text-white font-black text-xl mb-4 flex items-center gap-2">
            <i className="ri-shield-check-line text-[#FF4444]" />
            内容审核规则 · 免责声明
          </h2>
          <div className="space-y-2 mb-4">
            {CONTENT_RULES.map((rule, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5" style={{ background: 'rgba(255,68,68,0.15)', border: '1px solid rgba(255,68,68,0.3)' }}>
                  <span className="text-[#FF4444] text-xs font-bold">{i + 1}</span>
                </div>
                <p className="text-white/60 text-sm leading-relaxed">{rule}</p>
              </div>
            ))}
          </div>
          <div className="p-4 rounded-xl" style={{ background: 'rgba(255,68,68,0.08)', border: '1px solid rgba(255,68,68,0.2)' }}>
            <p className="text-[#FF4444] text-xs leading-relaxed font-semibold">
              免责声明：META66平台对用户上传的内容进行审核，但不对内容的真实性、准确性承担法律责任。
              用户对其上传内容承担全部法律责任。平台保留删除违规内容的权利，并有权向相关部门举报违法内容。
              本平台严格遵守中华人民共和国相关法律法规，包括但不限于《网络安全法》《互联网信息服务管理办法》等。
            </p>
          </div>
        </div>

        {/* Upload Form */}
        {submitted ? (
          <div className="text-center py-16 rounded-3xl" style={{ background: 'rgba(0,255,136,0.05)', border: '1px solid rgba(0,255,136,0.2)' }}>
            <div className="w-20 h-20 flex items-center justify-center rounded-full mx-auto mb-6" style={{ background: 'rgba(0,255,136,0.15)' }}>
              <i className="ri-check-line text-4xl" style={{ color: '#00FF88' }} />
            </div>
            <h3 className="text-white font-black text-2xl mb-3">作品提交成功！</h3>
            <p className="text-white/50 text-sm mb-2">您的作品已进入审核队列，审核周期为3-7个工作日。</p>
            <p className="text-white/40 text-xs mb-6">审核结果将发送至您的邮箱，请注意查收。</p>
            <Link to="/" className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-bold text-sm cursor-pointer whitespace-nowrap" style={{ background: 'rgba(0,255,136,0.15)', border: '1px solid rgba(0,255,136,0.3)', color: '#00FF88' }}>
              <i className="ri-home-line" />返回首页
            </Link>
          </div>
        ) : (
          <form data-readdy-form onSubmit={handleSubmit} className="space-y-6">
            <h2 className="text-white font-black text-xl flex items-center gap-2">
              <i className="ri-edit-line text-[#00FFCC]" />
              填写作品信息
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-white/60 text-sm font-semibold block mb-2">作者姓名 *</label>
                <input name="name" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required placeholder="请输入真实姓名或笔名" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
              </div>
              <div>
                <label className="text-white/60 text-sm font-semibold block mb-2">联系邮箱 *</label>
                <input name="email" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required placeholder="用于接收审核结果和收益通知" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
              </div>
            </div>

            <div>
              <label className="text-white/60 text-sm font-semibold block mb-2">故事标题 *</label>
              <input name="title" value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))} required placeholder="例如：《量子迷宫》" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-white/60 text-sm font-semibold block mb-2">科技主题 *</label>
                <input name="tech" value={form.tech} onChange={e => setForm(f => ({ ...f, tech: e.target.value }))} required placeholder="例如：量子计算、基因工程、AI" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
              </div>
              <div>
                <label className="text-white/60 text-sm font-semibold block mb-2">故事年代 *</label>
                <input name="year" value={form.year} onChange={e => setForm(f => ({ ...f, year: e.target.value }))} required placeholder="例如：2035" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
              </div>
            </div>

            <div>
              <label className="text-white/60 text-sm font-semibold block mb-2">故事简介 *（一句话吸引读者）</label>
              <input name="teaser" value={form.teaser} onChange={e => setForm(f => ({ ...f, teaser: e.target.value }))} required placeholder="例如：当量子计算机破解了所有密码，人类文明的秘密将无处遁形……" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="text-white/60 text-sm font-semibold">故事正文 *（第一章，至少500字）</label>
                <span className="text-white/30 text-xs">{charCount}/500字</span>
              </div>
              <textarea name="content" value={form.content} onChange={e => { setForm(f => ({ ...f, content: e.target.value })); setCharCount(e.target.value.length); }} required minLength={500} maxLength={500} placeholder="请输入故事第一章内容，至少500字。内容须符合中国法律法规，不得包含违禁内容。" rows={12} className="w-full px-4 py-3 rounded-xl text-sm outline-none resize-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
              <p className="text-white/30 text-xs mt-1">注：正文限制500字，完整故事请在审核通过后通过邮件提交</p>
            </div>

            <div>
              <label className="text-white/60 text-sm font-semibold block mb-2">收款账号（支付宝）</label>
              <input name="payAccount" value={form.payAccount} onChange={e => setForm(f => ({ ...f, payAccount: e.target.value }))} placeholder="请输入支付宝账号（手机号或邮箱），用于收益结算" className="w-full px-4 py-3 rounded-xl text-sm outline-none" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' }} />
            </div>

            <div className="flex items-start gap-3 p-4 rounded-xl" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <button type="button" onClick={() => setAgreed(!agreed)} className="w-5 h-5 flex items-center justify-center rounded flex-shrink-0 mt-0.5 cursor-pointer transition-all" style={{ background: agreed ? '#00FFCC' : 'transparent', border: `2px solid ${agreed ? '#00FFCC' : 'rgba(255,255,255,0.3)'}` }}>
                {agreed && <i className="ri-check-line text-black text-xs" />}
              </button>
              <p className="text-white/50 text-xs leading-relaxed">
                我已阅读并同意上述所有内容审核规则和免责声明。我保证上传的内容为原创作品，不违反中华人民共和国相关法律法规，不侵犯任何第三方权益。我理解并接受平台的审核机制和收益分成规则。
              </p>
            </div>

            <button type="submit" disabled={!agreed} className="w-full py-4 rounded-2xl font-black text-base transition-all cursor-pointer whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed" style={{ background: agreed ? 'linear-gradient(135deg, #FFD700, #FF6B35)' : 'rgba(255,255,255,0.1)', color: agreed ? '#000' : '#fff', fontFamily: 'Orbitron, sans-serif', fontSize: '0.85rem' }}>
              <i className="ri-upload-cloud-line mr-2" />提交作品审核 →
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
